package com.patronat.top.features.venues.domain.usecase.command

import com.patronat.top.dto.VenueFilterRequest

data class GetFilteredVenuesCommand(
    val filter: VenueFilterRequest
)
